module.exports = __webpack_public_path__ + "img/immersion.95d79d71.png";